import Axios from "axios";
import User from "./User";
import Configuration from "./Configuration";
import store from "../src/store";

/**
 * @typedef Lease
 * @property {Number} property
 * @property {Number} unit
 * @property {Number} unitNumber
 * @property {Date} startAt
 * @property {Date} endAt
 * @property {Date} earlyCancelAt
 * @property {String} cancelNote
 * @property {String} paymentNumber
 * @property {Boolean} active
 */

export default class Lease {

  constructor() {
    this.property = /** @type {Number} */ null;
    this.unit = /** @type {Object} */ null;
    this.unitNumber = /** @type {Object} */ null;
    this.startAt = /** @type {Date} */ null;
    this.endAt = /** @type {Date} */ null;
    this.earlyCancelAt = /** @type {Date} */ null;
    this.cancelNote = /** @type {String} */ null;
    this.paymentNumber = /** @type {String} */ null;
    this.active = /** @type {Boolean} */ false;
  }

  /**
   * @param {string} id
   * @return {Lease}
   */
  async get(id) {
    if (!User.token) {
      return;
    }
    let result = await Axios.get(CONFIG.urlServer + "/api/leases/" + id, {
      params: {
        property: store.state.property
      },
      headers: {
        "Authorization": "Bearer " + User.token
      }
    });
    this.load(result.data);
  }

  /**
   *
   * @param {any} definition
   */
  load(definition) {
    this.property = definition.property;
    this.unit = definition.unit;
    this.unitNumber = definition.unitNumber;
    this.startAt = Date.parse(definition.startAt);
    this.endAt = Date.parse(definition.endAt);
    this.earlyCancelAt = definition.earlyCancelAt ? Date.parse(definition.earlyCancelAt) : undefined;
    this.cancelNote = definition.cancelNote;
    this.paymentNumber = definition.paymentNumber;
    this.active = definition.computed ? definition.computed.active : false;
  }
}